import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMessage } from "@/lib/api";
import { Header } from "@/components/Header";
import { CallingCard } from "@/components/CallingCard";
import { useAuth } from "@/context/AuthContext";
import { Bookmark, ArrowRight } from "lucide-react";

export default function Saved() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [saved, setSaved] = useState([]);
  const [ids, setIds] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const res = await api.get("/saved");
      setSaved(res.data.saved || []);
      setIds(res.data.ids || []);
    } catch (e) {
      if (e?.response?.status === 402) navigate("/paywall");
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const toggleSave = async (uid) => {
    try {
      if (ids.includes(uid)) {
        const res = await api.delete(`/saved/${uid}`);
        setIds(res.data.ids || []);
        setSaved((prev) => prev.filter((p) => p.user_id !== uid));
        toast("Removed from your playlist");
      }
    } catch (e) { toast.error(errMessage(e)); }
  };

  const message = (uid) => navigate(`/messages?to=${uid}`);

  return (
    <div className="min-h-screen bg-ink">
      <Header />
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 pt-24 pb-20">
        <div className="flex items-end justify-between flex-wrap gap-3 mb-8">
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-gold">Your playlist</span>
            <h1 className="font-heading text-4xl md:text-6xl font-bold tracking-tighter uppercase text-cream mt-2">Saved HausCards</h1>
            <p className="text-ash mt-2 text-sm">Your top 15 writers of the moment. {ids.length}/15 saved.</p>
          </div>
          <Link to="/directory" data-testid="browse-more-link" className="inline-flex items-center gap-2 border border-line text-cream font-mono text-xs uppercase tracking-widest px-5 py-3 hover:border-gold hover:text-gold transition-colors">
            Browse The Haus <ArrowRight size={14} />
          </Link>
        </div>

        {loading ? (
          <div className="py-20 text-center font-mono text-xs uppercase tracking-[0.3em] text-ash animate-pulse">Loading…</div>
        ) : saved.length === 0 ? (
          <div className="border border-dashed border-line py-20 text-center">
            <Bookmark size={32} className="mx-auto mb-4 text-line" />
            <p className="text-cream font-heading text-xl mb-2">Your playlist is empty</p>
            <p className="text-ash text-sm mb-6">Tap the bookmark on any HausCard to save it here.</p>
            <Link to="/directory" className="inline-flex items-center gap-2 bg-gold text-ink font-bold uppercase tracking-widest text-xs px-6 py-3.5 hover:bg-gold-hi transition-colors">Find writers <ArrowRight size={15} /></Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {saved.map((p, i) => (
              <CallingCard key={p.user_id} profile={p} index={i} saved={true} onToggleSave={toggleSave} onMessage={message} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
